import cn from 'classnames';
import { ChangeEvent, FC, HTMLProps, MouseEvent } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { SizeType, VariantType } from '../../types/props';
import s from './chip.module.css';

export interface ChipProps extends Omit<HTMLProps<HTMLDivElement>, 'size' | 'id'> {
  size?: SizeType;
  variant?: VariantType;
  onDelete?: (e: MouseEvent<HTMLOrSVGElement>) => void;
  onSave?: () => void;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  active?: boolean;
}

export const Chip: FC<ChipProps> = (props) => {
  const { size = 'sm', variant, className, children, onDelete, active = false, ...other } = props;

  const classNames = cn(
    s.component,
    className,
    s[size],
    variant && s[variant],
    active && s.primary,
  );

  const handleDelete = (e: MouseEvent<HTMLOrSVGElement>) => {
    e.stopPropagation();
    onDelete?.(e);
  };

  return (
    <div {...other} className={classNames}>
      {children}
      {onDelete && <AiOutlineClose onClick={handleDelete} />}
    </div>
  );
};
